// import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import {
  Navbar,
  NavbarBrand,
  NavItem,
  // NavLink,
  Dropdown,
  UncontrolledCollapse,
  Button,
  Collapse,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Input
} from 'reactstrap';
import React, { Component } from 'react';
import { SvgAssets } from '../../../assets/icons/iconSvg';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { data } from '../../../constants/Constants';
import c from '../../../constants/Colors';
import localStorageCustom from '../../../utilitarios/localStorage';
import { AuthContext } from "../../../store/provider/AuthProvider";
import { askNotificacion } from '../../../utilitarios/util'

const LISTADO = [
  {
    screen: "/dashboard",
    title: "Dashboard",
    icon: "icon-chart",
    class: "mobile",
    color: c.azulClaro,
  },
  {
    title: "Cuenta",
    color: c.verdeClaro,
    icon: "icon-user",
    class: "mobile verde",
    list: [
      { name: "Mi perfil", screen: "/perfil", },
      { name: "Cambiar Perfil", screen: "/linea-negocio", }
    ]
  },
  {
    title: "Pedidos",
    color: c.morado,
    icon: "icon-list-check",
    class: "morado",
    list: [
      { name: "Generar Pedidos", screen: "/generar-pedido" },
      { name: "Generar Pedidos Masivos", screen: "/generar-pedido-masivo", },
      { name: "Historial de Pedidos", screen: "/historial-pedidos" },
      { name: "Pedidos Sugeridos", screen: "/pedido-sugerido", }
    ]
  },
  {
    title: "Más comprados y ofertas",
    color: c.naranja,
    icon: "icon-list-2",
    class: "naranja",
    list: [
      { name: "Productos más comprados", screen: "/productos-comprados" },
      { name: "Ofertas", screen: "/ofertas", icon: 'icon-oferta' }
    ]
  },
  {
    screen: "/estado-cuenta",
    title: "Estado de cuenta",
    icon: "icon-moneda",
    class: " ",
    color: c.azulClaro,
  },
  {
    screen: "/bonificaciones",
    title: "Metas y bonificaciones",
    icon: "icon-verified",
    class: " ",
    color: c.azulClaro,
  },
  {
    screen: "/pre-pedidos",
    title: "Pre-Pedidos",
    icon: "icon-edit",
    color: c.azulClaro,
  },
  {
    title: "Ayuda",
    color: c.azulClaro,
    icon: "icon-help",
    class: "bottom mobile",
    list: [
      { name: "Preguntas frecuentes", screen: "/preguntas-frecuentes" },
      { name: "Sugerencias", screen: "/sugerencias" },
      // { name: "Incidentes", screen: "/incidente" },
      // { name: "Requerimientos", screen: "/requerimientos"}
    ]
  },
];

const VEHICULO_LISTADO = [
  {
    screen: "/vehiculo-dashboard",
    title: "Inicio",
    icon: "icon-chart",
    class: "",
    color: c.azulClaro,
  },
  {
    title: "Ayuda",
    color: c.azulClaro,
    icon: "icon-help",
    class: "bottom",
    list: [
      { name: "Preguntas frecuentes", screen: "/preguntas-frecuentes" },
      { name: "Sugerencias", screen: "/sugerencias" },
    ]
  },
]

function OpcionMenu({ dadComponent }) {
  let list = (dadComponent.state.perfilVehiculos ? VEHICULO_LISTADO : LISTADO) || [];
  let optionsItem = [];
  if (list.length > 0) {
    // console.log('LISTADO',LISTADO)
    let collapseItem = dadComponent.state.collapseItem;
    list.map((item, index) => {
      optionsItem.push(
        <div className={`item ${item.class}`} key={index}>
          {item.list ?
            <div className="item-header" onClick={() => { dadComponent.state.collapseItem === index ? dadComponent.setState({ collapseItem: null }) : dadComponent.ToggleCollapseItem(index) }}>
              <SvgAssets icon={item.icon} fill={item.color} />
              <h6 style={{ color: item.color }}>{item.title}</h6>
              <SvgAssets className="arrow" icon={collapseItem === index ? "icon-top" : "icon-bottom"} fill={item.color} />
            </div> :
            <Link to={item.screen} className="item-header" onClick={() => { dadComponent.state.width < data.isSmallDevice ? dadComponent.toggleNavbar() : dadComponent.toggleDropdown() }} >
              <SvgAssets icon={item.icon} fill={item.color} />
              <h6>{item.title}</h6>
            </Link>
          }
          {item.list ?
            <Collapse className="item-body" isOpen={dadComponent.state.collapseItem === index}>
              <ul>
                {item.list.map((subOption, i) => (
                  <li key={`sub${i}`}><Link to={subOption.screen} className="link" onClick={() => { dadComponent.state.width < data.isSmallDevice ? dadComponent.toggleNavbar() : dadComponent.toggleDropdown() }}>
                    {subOption.icon ? <SvgAssets icon={subOption.icon} fill={'#fff'} /> : null}{subOption.name}</Link>
                  </li>
                ))}
              </ul>
            </Collapse> : null
          }
        </div>
      );
    });
  }
  return optionsItem;

}

const Drawer = ({ dadComponent, auth, cerrarSession }) => {
  const { collapsed } = dadComponent.state;
  return (
    <div className={collapsed ? "drawer" : "drawer open"}>
      <SvgAssets icon="curve-top" className="desktop curve" fill={c.celesteClaro} />
      <div className="rs">
        <Button color="link" className="close-menu mobile" onClick={() => dadComponent.toggleNavbar()}>
          <SvgAssets icon="icon-close" fill={c.rojoClaro} />
        </Button>
        <h3 className="title-2">{auth.userRazonSocial}</h3>
        <span>Repuestos</span>
        <SvgAssets icon="curve-top" className="curve-bottom mobile" fill={'#fff'} />
      </div>
      <div className="list-items">
        <OpcionMenu dadComponent={dadComponent} />
        <hr className="desktop" style={{ borderColor: c.celeste }} />
        <div className="desktop">
          <Link to="/perfil" className="link-item item bottom verde" onClick={() => dadComponent.toggleDropdown()}>
            <div className="item-header">
              <SvgAssets icon="icon-user" fill={c.verdeClaro} />
              <h6>Mi perfil</h6>
            </div>
          </Link>
          <Link to="/linea-negocio" className="link-item item bottom" onClick={() => dadComponent.toggleDropdown()}>
            <div className="item-header">
              <SvgAssets icon="icon-refresh" fill={c.azulClaro} />
              <h6>Cambiar Perfil</h6>
            </div>
          </Link>
        </div>
        <a href="#" className="item bottom" style={{ marginTop: 0 }} onClick={(e) => { e.preventDefault(); cerrarSession(); }}>
          <div className="item-header">
            <SvgAssets icon="icon-exit" fill={c.azulClaro} />
            <h6>Cerrar sesión</h6>
          </div>
        </a>
        <Link to="/eliminar-cuenta" onClick={() => { dadComponent.state.width < data.isSmallDevice ? dadComponent.toggleNavbar() : dadComponent.toggleDropdown() }} className="item bottom" style={{ marginTop: 0 }}>
          <div className="item-header">
            <SvgAssets icon="icon-trash" fill={c.rojo} />
            <h6 style={{ color: c.rojo }}>Eliminar cuenta</h6>
          </div>
        </Link>
      </div>
    </div>
  )
}

export class NavMenu extends Component {
  static displayName = NavMenu.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.state = {
      collapsed: true,
      collapsed2: true,
      width: window.innerWidth,
      collapseItem: false,
      dropdownOpen: false,
      perfilVehiculos: false,
    };
  }

  toggleNavbar = () => {
    // debugger;
    // document.querySelector(".nav-link")
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  toggleDropdown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  ToggleCollapseItem = (index) => {
    this.setState({ collapseItem: index })
  }

  authHeader(isLoggedIn) {
    if (isLoggedIn) {
      return (this.renderHeader(isLoggedIn));
    }
    return null;
  }

  componentDidUpdate() {
    if (this.state.collapsed) {
      document.getElementsByTagName('html')[0].style.overflow = "inherit";
    } else {
      document.getElementsByTagName('html')[0].style.overflow = "hidden";
    }
  }

  renderHeader() {
    const auth = this.context;
    console.log(auth.carritoProdctos);
    return (
      <div>
        {/* <Menu dadComponent={this} /> */}
        <Navbar className="navbar-expand-sm navbar-toggleable-sm box-shadow" fixed="top">
          {/* <Container> */}
          <NavbarBrand tag={Link} to="/dashboard">
            <img className='logo' src={require('../../../assets/img/isologo.png')} />
            <SvgAssets icon="curve-bottom" className='curve-bottom' fill="#fff" />
          </NavbarBrand>
          <ul className="navbar-nav ml-auto">
            <NavItem>
              <NavLink activeClassName="active" to='/dashboard' className="desktop nav-link">
                <SvgAssets icon="icon-home" fill={c.celeste} />
              </NavLink>
            </NavItem>
            {this.state.perfilVehiculos ?
              <NavItem>
                <NavLink className="nav-link" to="/representante-venta">
                  <SvgAssets icon="icon-supervisor" fill={c.celeste} />
                </NavLink>
              </NavItem> : null
            }
            <NavItem>
              <NavLink activeClassName="active-wish" className="nav-link" to="/lista-deseos">
                <SvgAssets icon="icon-star" fill={c.celeste} />
              </NavLink>
            </NavItem>
            <UncontrolledDropdown className="notificaciones">
              {(auth.dealerAlertas || []).length > 0 ?
                <DropdownToggle nav>
                  <SvgAssets icon="icon-campana" fill={c.celeste} />
                  {(auth.dealerAlertas || []).length > 0 ?
                    <span className="dot" />
                    : null
                  }
                </DropdownToggle>
                :
                <NavLink activeClassName="active" className="nav-link" to="/notificaciones">
                  <SvgAssets icon="icon-campana" fill={c.celeste} />
                </NavLink>
              }
              {(auth.dealerAlertas || []).length > 0 ?
                <DropdownMenu right>
                  <SvgAssets icon="curve-small" className="curve" fill='#fff' />
                  <div className="scroll-content">
                    {auth.dealerAlertas.map((alerta, index) => {
                      return (
                        <div className="dropdown-item" key={index}>
                          <div className="item">
                            <p>{alerta.mensaje}</p>
                            {(alerta.fechaHace == null) ?
                              <span>{alerta.fecha} {alerta.hora}</span>
                              :
                              <span>{alerta.fechaHace}</span>
                            }
                          </div>
                        </div>
                      )
                    })
                    }
                  </div>
                  {/* <DropdownItem>
                    <div className="item">
                      <p>El pedido N° 9999999999, vence en 5 horas.</p>
                      <span>9:50 a.m.</span>
                    </div>
                  </div>
                  <div className="dropdown-item">
                    <div className="item">
                      <p>Actualice su contraseña, recuerda que tu actual contraseña vence en 3 días.</p>
                      <span>Hace 1d</span>
                    </div>
                  </DropdownItem> */}
                  {(auth.dealerAlertas || []).length > 0 ?
                    <DropdownItem tag="div" className="link-u" style={{ padding: 0, display: 'flex', justifyContent: 'flex-end' }}>
                      <Link activeClassName="active" className="link link-u bold" to="/notificaciones" style={{ margin: 0 }}>
                        Ver todos
                      </Link>
                    </DropdownItem>
                    : null
                  }
                  {/* <Link className="link-u" to="/notificaciones">Ver todos</Link> */}
                </DropdownMenu>
                : null
              }
            </UncontrolledDropdown>
            <NavItem>
              <NavLink activeClassName="active" to="/carrito" className="nav-link">
                <SvgAssets icon="icon-carrito" />
                {(auth.carritoProdctos > 0) ?
                  <span className="dot cart">{auth.carritoProdctos}</span>
                  : null}
              </NavLink>
            </NavItem>
            <NavItem className="mobile">
              <Button color="link" className="btn-menu" onClick={() => this.toggleNavbar()}>
                <SvgAssets icon="icon-menu" />
              </Button>
            </NavItem>
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown} className="dropdown-drawer">
              <DropdownToggle nav>
                <SvgAssets icon="icon-user" fill="#fff" className="icon-user" />
                {/* Razón Social S.A */}
                {auth.userRazonSocial}
                <SvgAssets icon="icon-bottom" fill={c.azulClaro} className="arrow" />
              </DropdownToggle>
              <DropdownMenu right>
                <Drawer dadComponent={this} auth={auth} cerrarSession={this.cerrarSession} />
              </DropdownMenu>
            </Dropdown >
          </ul>
          {/* </Container> */}
        </Navbar>
        <div className={`bg-drawer ${this.state.collapsed ? '' : 'show'}`} />
        {this.state.width < data.isSmallDevice ?
          <Drawer dadComponent={this} auth={auth} cerrarSession={this.cerrarSession} /> : null
        }
      </div>
    )
  }

  render() {
    const { isLoggedIn } = this.props;
    return (
      <header>
        {this.authHeader(isLoggedIn)}
      </header>
    );
  }

  toggleModalAlertAsk = () => {
    askNotificacion('Cerrar sesión', '¿Esta seguro de cerrar sesión?', () => {
      const auth = this.context;
      localStorageCustom.prototype.removeToken();
      localStorageCustom.prototype.removeUsuario();
      auth.setuserToken(null);
      auth.setIsLoggedIn(false);
      // history.pushState(null, null, '/');
      window.location.href = "/";
    })
  }

  cerrarSession = () => {
    this.toggleModalAlertAsk();
    // this.props.history.push('/');
  }
}
